import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { Client } from '@app/shared/models/client';
import { ClientUserUriBuilderParams, UserService } from '@app/core/services/user.service';
import { forkJoin } from 'rxjs';
import { BaseWithIdList } from '@app/shared/models/list';
import { ClientUser, ClientUserQueryResult, ClientUserState } from '@app/shared/models/client-user';
import { TranslationEntry } from '@app/shared/models/translatable';
import { SMPLog } from '@app/shared/models/log';
import { ActivatedRoute } from '@angular/router';
import { CaseLogService } from '@app/core/services/case-log.service';


@Component({
    templateUrl: './case-activity-log.component.html',
    styleUrls: ['./case-activity-log.component.scss']
})
export class CaseActivityLogComponent extends BaseWithBundleComponent
                                      implements OnInit, OnDestroy {

    protected client: Client;
    protected caseId: string;
    protected caseNr: string;

    public userList: BaseWithIdList<ClientUser>;
    public selectedUserId: string;
    protected availableUserIds: string[];

    public logCategories: TranslationEntry[];
    public selectedLogCategory: string;
    protected availableCategoryKeys: string[];

    public logs: BaseWithIdList<SMPLog>;

    public searchText: string;

    get filterIsDefault(): boolean {
        return !this.searchText &&
               !this.selectedLogCategory &&
               !this.selectedUserId;
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected route: ActivatedRoute,
                protected logService: CaseLogService,
                protected userService: UserService) {
        super(componentServiceBundle);
        this._idPrefix = 'case_activity_log.';
    }

    public ngOnInit() {
        super.ngOnInit();
        this.caseId = this.route.snapshot.paramMap.get('id');

        if (this.drI18nService.loadedTransFile) {
            this.initialize();
        } else {
            this.subscriptions.push(
                this.drI18nService.loadedTransFileSubject
                                  .subscribe(result => {
                    if (result) {
                        this.initialize();
                    }
                })
            );
        }
    }

    public ngOnDestroy() {
        super.ngOnDestroy();
    }

    protected initialize(): void {

        const allTranslated = `-- ${this.translateService.instant(marker('common.label.all'))} --`;

        const dropDownEntryAll = {
            key: '',
            trans: allTranslated
        };

        this.client = this.authenticationService.currentUserValue.client;

        this.resetFilters();

        const observables = [
            this.userService.query(new ClientUserUriBuilderParams(this.client)),
            this.logService.getCaseLogCategories(),
            this.logService.getCaseLogs(this.caseId)
        ];

        forkJoin(observables).subscribe((results: any) => {
            const users: BaseWithIdList<ClientUser> = (<ClientUserQueryResult>results[0]).users;
            users.items = users.items.filter(user => user.state !== ClientUserState.NOTINVITED && user.state !== ClientUserState.TEMPORARY);
            this.userList = users;
            this.userList.items.unshift(new ClientUser({ id: '', user_code: allTranslated }));

            this.logCategories = results[1];
            this.logCategories.unshift(Object.assign({}, dropDownEntryAll));

            this.logs = results[2].logs;
            this.caseNr = results[2].case_no;
            this.availableCategoryKeys = results[2].categories;
            this.availableUserIds = results[2].case_no;
            this.buildBreadcrumb();
        }, err => {
            this.handleError(err);
        });
    }

    protected buildBreadcrumb(): void {
        this.breadcrumbsService.breadcrumbs.unshift({ url: '#', label: this.caseNr, disabled: true });
    }

    public userUnAvailable(user): boolean {
        return !user || !user.id || !this.availableUserIds || this.availableUserIds.indexOf(user.id) === -1;
    }

    public categoryUnAvailable(category): boolean {
        return !category || !category.key || !this.availableCategoryKeys || this.availableCategoryKeys.indexOf(category.key) === -1;
    }

    public resetFilters(): void {
        this.searchText = '';
        this.selectedLogCategory = '';
        this.selectedUserId = '';
    }

    public applyFilters(): void {
        this.logService.getCaseLogs(this.caseId, this.selectedLogCategory, this.selectedUserId, this.searchText)
                       .subscribe(result => {
            this.logs = result.logs;
        });
    }

}
